<template>
  <b-modal
    id="create-material-modal"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    centered
    :title="`Create / Edit ${type}`"
    size="xl"
    :hide-header-close="false"
    :modal-class="`select-slide-modal upload-slide`"
    body-class="pb-1"
    v-on:shown="showForm"
  >
    <!-- <form @submit.prevent="submitForm"> -->
    <div class="modal-class upload-slide-class">
      <div
        class="align-items-center d-flex flex-column justify-content-center position-relative"
      >
        <div class="w-100" :class="{ 'fetch-class': formLoading }">
          <div class="pb-2 row px-xl-3">
            <div class="col-12 col-xl-2">
              <label for="id">ID</label>
            </div>
            <b-col class="col-12 col-xl-10 px-20">
              <b-row>
                <div class="col-4 px-0" style="margin-right: 5px">
                  <b-form-input
                    placeholder="Type temporary ID"
                    aria-label="ID"
                    aria-labelledby="ID"
                    type="text"
                    name="id"
                    v-model="form.id"
                    size="sm"
                    v-validate="'required'"
                    :state="errors.has('id') ? false : null"
                    :readonly="form.systemIdNumber ? true : false"
                  >
                  </b-form-input>
                </div>
                <div class="" v-if="type !== 'Assignment'">
                  <small style="opacity: 0.8" class="text-primary">
                    ID will be automatically changed after moving item into
                    Published folder.
                  </small>
                </div>
              </b-row>
            </b-col>
          </div>

          <!-- Name -->
          <div class="pb-2 row px-xl-3">
            <div class="col-12 col-xl-2">
              <label for="name">Title</label>
            </div>
            <b-col class="col-12 col-xl-10 px-20">
              <b-row>
                <div class="col-12 px-0">
                  <b-form-input
                    placeholder="Name to display on public website, max 80 characters"
                    aria-label="Name"
                    aria-labelledby="Name"
                    type="text"
                    name="name"
                    v-model="form.name"
                    size="sm"
                    maxlength="80"
                    v-validate="'required'"
                    :state="errors.has('name') ? false : null"
                  >
                  </b-form-input>
                </div>
                <div class="col-left" style="width: 100%; text-align: right">
                  <small class="text-muted">
                    {{ form.name.length }}/80 characters
                  </small>
                </div>
              </b-row>
            </b-col>
          </div>

          <!-- Description -->
          <div class="pb-2 row px-xl-3">
            <div class="col-12 col-xl-2">
              <label>{{`Description of the ${type}`}}</label>
            </div>
            <b-col class="col-12 col-xl-10 px-20">
              <b-row>
                <div class="col-12 px-0">
                  <b-form-textarea
                    placeholder="Material Notes, max 300 characters"
                    aria-label="Description"
                    aria-labelledby="Description"
                    name="description"
                    v-model="form.description"
                    rows="2"
                    maxlength="300"
                    v-validate="'required'"
                    :state="errors.has('description') ? false : null"
                  >
                  </b-form-textarea>
                  <div class="d-flex justify-content-end">
                    <small class="text-muted"
                      >{{ form.description ? form.description.length : 0 }}/300
                      characters</small
                    >
                  </div>
                </div>
              </b-row>
            </b-col>
          </div>

          <!-- Tumor Site (we store object {id,name}) -->
          <div class="pb-2 row px-xl-3">
            <div class="col-12 col-xl-2">
              <label>Tumor Site</label>
            </div>
            <b-col class="col-12 col-xl-10 px-20">
              <b-row>
                <div class="col-6 px-0">
                  <p-dropdown
                    :aria-label="'Tumor Site'"
                    :aria-labelledby="'Tumor Site'"
                    :placeholder="'Select Tumor Site'"
                    name="tumorSite"
                    optionLabel="name"
                    class="p-dropdown-custom form-control form-control-sm"
                    v-model="form.tumorSite"
                    :options="tumorSites"
                    v-validate="'required'"
                    :class="errors.has('tumorSite') ? 'invalid' : ''"
                  >
                  </p-dropdown>
                </div>
              </b-row>
            </b-col>
          </div>

          <div class="pb-2 row px-xl-3">
            <div class="col-12 col-xl-2">
              <label>Target Audience</label>
            </div>
            <b-col class="col-12 col-xl-10 px-20">
              <b-row>
                <div class="col-6 px-0">
                  <p-dropdown
                    :aria-label="'Target Audience'"
                    :aria-labelledby="'Target Audience'"
                    :placeholder="'Select Target Audience'"
                    name="difficultyLevel"
                    optionLabel="name"
                    class="p-dropdown-custom form-control form-control-sm"
                    v-model="form.difficultyLevel"
                    :options="difficultyLevels"
                    v-validate="'required'"
                    :class="errors.has('difficultyLevel') ? 'invalid' : ''"
                  >
                  </p-dropdown>
                </div>
              </b-row>
            </b-col>
          </div>

          <div class="pb-2 row px-xl-3">
            <div class="col-12 col-xl-2"></div>
            <b-col class="col-12 col-xl-10 px-20">
              <b-row>
                  <div class="col-6 px-0">
                    <p-dropdown
                      :aria-label="`${type} Collection`"
                      :aria-labelledby="`${type} Collection`"
                      :placeholder="`Select ${type} Collection`"
                      name="slideCollection"
                      optionLabel="name"
                      class="p-dropdown-custom form-control form-control-sm"
                      v-model="form.slideCollection"
                      :options=" type === 'Presentation' ? presentationCollections : slideCollections"
                      v-validate="'required'"
                      v-if="type === 'Collection' || type === 'Presentation'"
                      :class="errors.has('slideCollection') ? 'invalid' : ''"
                    >
                    </p-dropdown>
                  </div>
                </b-row>
                <b-row class="mt-2">
                  <template v-if="(form.slideCollection && form.slideCollection.value === 'VIEW_HIDE_DIAGNOSIS') || type === 'Assignment'">
                    <b-form-checkbox
                      name="hideDemographics"
                      aria-label="hideDemographics"
                      aria-labelledby="hideDemographics"
                      size="sm"
                      v-model="form.hideDemographics"
                    >
                      Hide Patient demographic information
                    </b-form-checkbox>
                  </template>
              </b-row>
            </b-col>
          </div>

          <!-- WTR Recommended Option -->
          <!-- <div
            class="pb-2 row px-xl-3"
            v-if="
              userRole === ROLE_CHAIRPERSON ||
              userRole === ROLE_TENANT_ADMIN || 
              userRole === ROLE_PROJECT_ADMIN
            "
          >
            <div class="col-12 col-xl-2"></div>
            <b-col class="col-12 col-xl-10 px-20">
              <b-row>
                <div class="" v-if="type !== 'Assignment'">
                  <b-form-radio-group
                    v-model="form.isRecommendedWtr"
                    name="isRecommendedWtr"
                  >
                    <b-form-radio :value="true" class="mr-3">
                      Publish as (WTR recommended)
                    </b-form-radio>
                    <b-form-radio :value="false">
                      Publish as "Created by WTR user"
                    </b-form-radio>
                  </b-form-radio-group>
                </div>
              </b-row>
            </b-col>
          </div> -->

          <!-- Populate virtual tray -->
          <header class="modal-header modal-subheader mt-4" name="virtual-tray">
            <h5 class="modal-title">
              Populate virtual tray with published WTR tumor cases
            </h5>
          </header>
          <div class="row" style="margin-top: 10px">
            <div class="col-12">
              <b-button
                variant="primary"
                size="sm"
                @click="manageSelectionofTumorSite()"
                class="mb-3 btn btn-primary px-4 rounded-pill"
              >
                Add Tumor Case
              </b-button>

              <b-button
                variant="primary"
                size="sm"
                @click="openPresentationSlideSelector()"
                class="mb-3 btn btn-primary px-4 rounded-pill mx-4"
                v-if="type === 'Presentation'"
              >
                Add PPT Slides
              </b-button>
            </div>
            <div
              class="col-12"
              v-if="tumorCasesLoading"
              style="position: relative; margin-bottom: 20px"
            >
              <div
                class="w-100 h-100 position-absolute align-items-center d-flex justify-content-center"
                style="
                  top: 0;
                  left: 0;
                  background: rgba(255, 255, 255, 0.8);
                  z-index: 10;
                "
              >
                <wtr-loader
                  class="text-primary pb-3"
                  loadingText="Loading..."
                  addText
                ></wtr-loader>
              </div>
            </div>
          </div>

          <!-- Modal 1: Paste comma-separated case numbers -->
          <b-modal
            id="modal-add-tumor"
            title="PROVIDE ID OF WTR TUMOR CASES"
            size="md"
            hide-footer
          >
            <div class="mb-3">
              <textarea
                v-model="caseIds"
                class="form-control"
                rows="3"
                :placeholder="caseNumberPlaceholder"
              ></textarea>
            </div>
            <div class="mb-3">
              <button
                class="btn btn-primary px-4 rounded-pill"
                @click="handleAddCasesClick"
              >
                Add cases to
                {{ type === "Collection" ? "collection" : "assignment" }}
              </button>
            </div>

            <hr />

            <div class="mb-2 font-weight-bold text-primary">
              BROWSE WTR TUMOR CASES
            </div>
            <div class="">
              <button
                class="btn btn-primary px-4 rounded-pill"
                @click="$bvModal.show('modal-select-manual')"
              >
                Select cases manually
              </button>
            </div>
          </b-modal>

          <!-- Modal 2: Placeholder manual selector (you can fill this) -->
          <b-modal
            id="modal-select-manual"
            class="modal-manual-case"
            title="Select Cases Manually"
            size="xl"
            hide-footer
            @shown="getAllMetaData"
          >
            <section class="search-result position-relative p-2">
              <!-- Top Filters -->
              <manual-case-filter
                :totalCases="totalElements"
                @search="onSearchTopFilter"
                @clear="onClearList"
                @gridMode="onGridMode"
                @addmanual="handleManuallySelectedCases"
                :type="type"
                :selectedtumorSiteId="Number(selectedTumorSiteId)"
              />
              <div
                v-if="listLoading"
                class="w-100 h-100 align-items-center d-flex justify-content-center"
              >
                <wtr-loader
                  class="text-primary pb-3"
                  loadingText=" Fetching Cases..."
                  addText
                ></wtr-loader>
              </div>
              <div
                class="row m-0 w-100 flex-md-row-reverse"
                :class="{ 'fetch-class': listLoading }"
              >
                <!-- Grid View -->
                <div
                  v-if="gridType"
                  class="col-12 col-md-9 col-lg-12 result-containter"
                >
                  <div class="row diagnosis-grid">
                    <div
                      class="col-auto mx-auto mx-md-0 px-md-2 diagnosis-grid-item"
                      v-for="item in searchResult"
                      :key="item.caseNumber"
                    >
                      <div class="diagnosis-box pd-0">
                        <div class="row justify-content-between">
                          <div class="col-auto">
                            <div
                              class="case-header p-2 pt-0 diagnosis-box-case-info"
                            >
                              <span class="d-block text-primary small">
                                Case #:
                                <span class="diagnosis-box-case-number">
                                  {{ item.caseNumber }}
                                </span>
                              </span>
                              <span class="d-block text-primary small">
                                Total slides:
                                <span class="diagnosis-box-case-number">{{
                                  item.totalFiles || 0
                                }}</span>
                              </span>
                            </div>
                          </div>
                          <div class="col-auto">
                            <b-form-checkbox
                              :id="`chk-${item.caseNumber}`"
                              :value="item.caseNumber"
                              v-model="selectedCases"
                              class="d-inline-block"
                            ></b-form-checkbox>
                          </div>
                        </div>

                        <div
                          class="diagnosis-img-box position-relative w-100 cursor-pointer"
                          @click="viewSlide(item)"
                        >
                          <wtr-img
                            :src="item.thumbnailPath"
                            :resourceId="item.resourceId"
                            :containerName="item.containerName"
                            alt="Thumbnail"
                            class="thum-img w-100 h-100"
                          />
                          <p class="p-text-dark diagnosis-text">
                            {{ item.tumorSite }} - {{ item.tumorType }} -
                            {{ item.tumorSubType }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="searchResult && searchResult.length > 0"
                    class="row m-0 mt-5 align-items-center px-2"
                    style="row-gap: 10px"
                  >
                    <div class="col-auto">
                      <b-pagination
                        size="sm"
                        pills
                        @change="handlePageChange"
                        class="m-0"
                        :value="paramsUtil.page + 1"
                        :limit="3"
                        :per-page="paramsUtil.size"
                        :total-rows="totalElements"
                      ></b-pagination>
                    </div>

                    <div class="col-auto" v-if="totalElements > 1000">
                      <div class="info-text">
                        <i class="fa fa-info-circle"></i>
                        {{ $t("notes.maximumOf1000Records") }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Table View -->
                <div
                  v-else
                  class="col-12 col-md-9 col-lg-10 result-containter-table"
                >
                  <result-table
                    :searchResult="searchResult"
                    :tableFields="tableFields"
                    @sortMetadata="sortMetadata"
                    @viewSlide="viewSlide"
                  />
                </div>
              </div>
            </section>
          </b-modal>

          <b-modal
            id="modal-select-presentation-slides"
            title="Select Presentation Slides"
            size="xl"
            hide-footer
            @shown="loadPresentationList"
          >
            <section class="position-relative p-2">
              <div
                v-if="presentationsLoading || presentationSlidesLoading"
                class="w-100 h-100 align-items-center d-flex justify-content-center position-absolute"
                style="top: 0; left: 0; background: rgba(255, 255, 255, 0.8); z-index: 10"
              >
                <wtr-loader
                  class="text-primary pb-3"
                  loadingText=" Fetching Slides..."
                  addText
                ></wtr-loader>
              </div>
              <div
                v-if="!presentationsLoading && !presentationList.length"
                class="text-muted py-4 text-center"
              >
                No presentation slides found. Please first upload PPT slides using My PPT Slides tool after clicking on your profile image.
              </div>
              <div v-else class="row" :class="{ 'fetch-class': presentationsLoading || presentationSlidesLoading }">
                <div class="col-12 col-md-4">
                  <h6 class="text-primary">Presentations</h6>
                  <div class="list-group presentation-list">
                    <button
                      v-for="presentation in presentationList"
                      :key="presentation.id"
                      type="button"
                      class="list-group-item list-group-item-action"
                      :class="{ active: selectedPresentation && selectedPresentation.id === presentation.id }"
                      @click="selectPresentation(presentation)"
                    >
                      {{ presentation.name || presentation.title }}
                    </button>
                  </div>
                </div>
                <div class="col-12 col-md-8">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h6 class="text-primary mb-0">Slides</h6>
                    <button
                      class="btn btn-primary px-4 rounded-pill"
                      :disabled="!selectedPresentationSlideIds.length"
                      @click="handlePresentationSlidesSelected"
                    >
                      Add selected slides
                    </button>
                  </div>
                  <div v-if="presentationSlides.length" class="row diagnosis-grid">
                    <div
                      class="col-6 col-md-4 col-lg-3 diagnosis-grid-item"
                      v-for="slide in presentationSlides"
                      :key="slide.id"
                    >
                      <div class="diagnosis-box pd-0">
                        <div class="row justify-content-between px-2">
                          <div class="col pr-0">
                            <span class="d-block text-primary small text-truncate">
                              {{ getDisplaySlideName(presentationSlides.indexOf(slide)) }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <b-form-checkbox
                              :id="`presentation-slide-${slide.id}`"
                              :value="slide.id"
                              v-model="selectedPresentationSlideIds"
                              class="d-inline-block"
                            ></b-form-checkbox>
                          </div>
                        </div>
                        <div class="diagnosis-img-box position-relative w-100">
                          <wtr-img
                            :src="slide.thumbnailPath || slide.path"
                            :resourceId="slide.resourceId"
                            :containerName="slide.containerName"
                            alt="Presentation slide"
                            class="thum-img w-100 h-100"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="text-muted py-4 text-center">
                    Select a presentation to view slides.
                  </div>
                </div>
              </div>
            </section>
          </b-modal>

          <!-- Rows: preview, order (numeric input), comment -->

          <div v-show="form.tumorCases && form.tumorCases.length" class="pb-2">
            <label class="mb-0">Selected tumor cases and presentation slides:</label>
            <div class="table-responsive" style="overflow: visible">
              <table class="table table-bordered" style="min-width: 900px">
                <thead>
                  <tr>
                    <th class="text-center fw-600 tumor-case-drag-column">Drag to Reorder</th>
                    <th class="text-center fw-600 w-12">Preview</th>
                    <!-- <th class="text-center fw-600 w-12">Type</th> -->
                    <th class="fw-600">
                      {{
                        type == "Assignment"
                          ? "Hint to help learner to diagnose (shown during assignment)"
                          : "Comment about the case (Optional, max 300 characters). Displayed when user unhides Diagnostic Information"
                      }}
                    </th>
                    <th v-if="type === 'Assignment'" class="fw-600">
                      Comments for the case to display in shared answers
                    </th>
                    <th class="text-center fw-600 w-10">Actions</th>
                  </tr>
                </thead>
                <draggable
                  v-model="form.tumorCases"
                  tag="tbody"
                  :options="{
                    handle: '.tumor-case-drag-handle',
                    animation: 150,
                    disabled:
                      isTumorCaseOrderSaving || form.tumorCases.length < 2,
                  }"
                  @start="handleTumorCaseDragStart"
                  @end="handleTumorCaseDragEnd"
                >
                  <tr
                    v-for="(caseItem, index) in form.tumorCases"
                    :key="caseItem.matCaseId || caseItem.caseId"
                  >
                    <td class="text-center tumor-case-drag-column">
                      <span
                        class="tumor-case-drag-handle text-muted"
                        :class="{
                          'drag-disabled':
                            isTumorCaseOrderSaving ||
                            form.tumorCases.length < 2,
                        }"
                        title="Drag to reorder"
                      >
                        <i
                          v-if="!isTumorCaseOrderSaving"
                          class="fa fa-bars"
                        ></i>
                        <i v-else class="fa fa-spin fa-spinner"></i>
                      </span>
                    </td>
                    <td class="text-center position-relative">
                      <div
                        :class="{ 'cursor-pointer': type === 'Assignment' && caseItem.itemType !== 'PRESENTATION_SLIDE' }"
                        :role="type === 'Assignment' && caseItem.itemType !== 'PRESENTATION_SLIDE' ? 'link' : null"
                        :tabindex="type === 'Assignment' && caseItem.itemType !== 'PRESENTATION_SLIDE' ? 0 : null"
                        @click="viewCaseInfo(caseItem)"
                        @keydown.enter="viewCaseInfo(caseItem, $event)"
                      >
                        <span class="fs-10 fw-600 pull-center p-2 text-primary" v-if="type === 'Assignment' && caseItem.caseNumber">{{ caseItem.caseNumber }}</span>
                        <wtr-img
                          imgClass="table-thumbnail"
                          :resourceId="caseItem.resourceId"
                          :containerName="caseItem.containerName"
                          :src="caseItem.src"
                          alt="Thumbnail"
                          aria-label="Thumbnail"
                          aria-labelledby="Thumbnail"
                        />
                      </div>
                    </td>
                    <!-- <td class="text-center fs-12">
                      {{ caseItem.itemType === "PRESENTATION_SLIDE" ? "Presentation Slide" : "Tumor Case" }}
                    </td> -->
                    <td>
                      <b-form-input
                        placeholder="300 characters"
                        aria-label="Comment"
                        aria-labelledby="Comment"
                        type="text"
                        v-model="caseItem.comment"
                        :name="`Comment_${caseItem.itemType || 'CASE'}_${caseItem.caseId || caseItem.presentationSlideId}`"
                        size="sm"
                        maxlength="300"
                      >
                      </b-form-input>
                    </td>
                    <td v-if="type === 'Assignment'">
                      <b-form-input
                        placeholder="600 characters"
                        aria-label="Answer comments"
                        type="text"
                        v-model="caseItem.answerComments"
                        :name="`AnswerComments_${caseItem.itemType || 'CASE'}_${caseItem.caseId || caseItem.presentationSlideId}`"
                        size="sm"
                        maxlength="600"
                      >
                      </b-form-input>
                    </td>
                    <td class="text-center">
                      <a
                        class="text-danger tab-delete-icon"
                        title="Delete Item"
                        v-on:click="removeCase(index)"
                      >
                        <i class="fa fs-20 fa-trash-o"></i>
                      </a>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>

          <header class="modal-header modal-subheader" name="terms">
            <h5 class="modal-title">Terms of using WTR resources</h5>
          </header>
          <div class="py-2">
            <div class="fs-12 text-justify text-primary">
              This is a World Tumor Registry (WTR) platform and should be used
              only for educational and exploratory purposes but not for direct
              diagnostic use. You are responsible for the accuracy of
              information uploaded in WTR. Although every effort has been made
              to de-identify patient health information from uploaded whole
              slide and other images, please verify that you do not see any
              images that display patient information on them after uploading
              them and before making them public. Any label and primary metadata
              associated with a whole slide pathology image will not be
              displayed in WTR. Patient information that should not be displayed
              include name, address (all geographic subdivisions smaller than
              state, including street address, city-county, and zip code), all
              elements (except years) of dates related to an individual
              (including birth date, admission date, discharge date, date of
              death, and exact age if over 89), telephone numbers, fax number,
              email address, social security number, medical record number,
              health insurance number, account number, certificate or license
              number, any vehicle or other device serial number, finger or voice
              print, photographic image (not limited to images of the face), any
              other characteristic that could uniquely identify the individual.
            </div>
            <div class="pt-2">
              <b-form-checkbox
                name="agreeTerms"
                aria-label="agreeTerms"
                aria-labelledby="agreeTerms"
                size="sm"
                v-model="form.agreeTerms"
                v-validate="'required'"
                :state="errors.has('agreeTerms') ? false : null"
              >
                I agree to the terms.
              </b-form-checkbox>
            </div>
          </div>

          <header class="modal-header modal-subheader" name="terms">
            <h5 class="modal-title">Created By</h5>
          </header>
          <div class="py-3 row px-xl-3 align-items-center">
            <div class="col-12 col-xl-4 mt-5">
              <b-form-input
                placeholder="Created By"
                aria-label="Created By"
                aria-labelledby="Created By"
                type="text"
                name="createdBy"
                v-model="form.createdBy"
                size="sm"
                v-validate="'required'"
                :state="errors.has('createdBy') ? false : null"
              >
              </b-form-input>
            </div>
            <div class="col-auto pt-25">
              <b-form-checkbox
                name="isShowPublicSiteEditor"
                aria-label="isShowPublicSiteEditor"
                aria-labelledby="isShowPublicSiteEditor"
                size="sm"
                v-model="form.isShowPublicSiteEditor"
              >
                Do NOT show name on WTR public website
              </b-form-checkbox>
            </div>
          </div>
          <header
            name="upload-modal-end"
            class="modal-header modal-subheader"
            style="padding: 1px 0px !important"
          ></header>

          <div
            class="pb-10 pt-10 pt-xl-0 row"
            v-show="form.tumorCases && form.tumorCases.length"
          >
            <b-col class="d-flex justify-content-end align-items-baseline">
              <div v-if="isUploadCaseProcess">
                <wtr-loader
                  class="mr-3 text-primary"
                  loadingText=" Wait..."
                  addText
                ></wtr-loader>
              </div>
              <b-button
                aria-label="save"
                aria-labelledby="save"
                :title="editId ? 'Update' : 'Save'"
                size="sm"
                variant="primary"
                @click="validateData"
                class="mr-2"
                :class="isUploadCaseProcess ? 'disabled' : ''"
              >
                {{ editId ? "Update" : "Save" }}
              </b-button>
              <b-button
                aria-label="cancel"
                aria-labelledby="cancel"
                title="Cancel"
                size="sm"
                variant="outline-primary"
                v-on:click="cancel"
                :class="isUploadCaseProcess ? 'disabled' : ''"
              >
                Cancel
              </b-button>
            </b-col>
          </div>

          <div>
            <div class="fs-14 text-center">
              Please send an email to
              <a href="mailto: support@worldtumorregistry.org"
                ><span class="fw-600">support@worldtumorregistry.org</span></a
              >
              if you encounter any issues while material creation.
            </div>
          </div>
        </div>

        <div
          v-if="formLoading"
          class="w-100 h-100 position-absolute align-items-center d-flex justify-content-center"
        >
          <wtr-loader
            class="text-primary pb-3"
            loadingText=" Fetching Material..."
            addText
          ></wtr-loader>
        </div>
      </div>
    </div>
    <!-- </form> -->
  </b-modal>
</template>

<script>
import * as roleTypes from "../../../constants/constants-role";
import manualCaseFilter from "./manual-case-filter.vue";
import { getTumorSiteCaseNumberPlaceholder } from "../../../constants/constants-tumor-site";
import draggable from "vuedraggable";

export default {
  name: "create-educational-material",
  components: {
    "manual-case-filter": manualCaseFilter,
    draggable,
    // Intersect,
  },
  props: {
    editId: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: "Collection", // fallback
    },
    currentFolder: {
      type: Object,
      default: null,
    },
    selectedUserId: {
      type: String,
      default: null,
    },
    tumorSites: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const getInitialFormState = () => ({
      id: "",
      name: "",
      description: "",
      tumorSite: null,
      difficultyLevel: "",
      hideCaseNotes: false,
      hideDemographics: false,
      enableUnhide: false,
      tumorCases: [],
      agreeTerms: false,
      createdBy: "",
      isShowPublicSiteEditor: false,
      isRecommendedWtr: false,
      slideCollection: null,
      slideCollectionType: null,
    });
    return {
      ...roleTypes,
      editing: false,
      form: getInitialFormState(),
      difficultyLevels: [
        { name: "Junior Residents", value: "Junior_Residents" },
        { name: "Pathology Fellows", value: "Pathology_Fellows" },
        { name: "Practicing Pathologist", value: "Practicing_Pathologist" },
        { name: "Mixed", value: "Mixed" },
        { name: "NA", value: "NA" },
      ],
      slideCollections: [
        { name: "Case Collection: Diagnosis Shown", value: "DIAGNOSIS_SHOWN" },
        { name: "Case Collection: View/Hide Diagnosis", value: "VIEW_HIDE_DIAGNOSIS"},
      ],
      presentationCollections: [
        { name: "Presentation: Diagnosis Shown", value: "DIAGNOSIS_SHOWN" },
        { name: "Presentation: View/Hide Diagnosis", value: "VIEW_HIDE_DIAGNOSIS"},
      ],
      caseIds: "",
      manuallCaseIds: "",
      userRole: localStorage.getItem("userRole"),
      removedCases: [],
      searchResult: [],
      listLoading: false,
      formLoading: false,
      tumorCasesLoading: false,
      gridType: true,
      filterList: {},
      sizeOptions: [5, 10, 20, 50, 100],
      paramsUtil: {
        page: 0,
        size: 10,
        sort: "cd.system_case_number,desc",
        isSorted: false,
      },
      tableFields: [
        { key: "caseNumber", label: "Case Number", columnClass: "case-width" },
        { key: "tumorSite", label: "Tumor Site" },
        { key: "tumorType", label: "Tumor Type" },
        { key: "tumorSubType", label: "Tumor Subtype" },
        { key: "geographicRegion", label: "Region" },
        { key: "country", label: "Country" },
        { key: "age", label: "Age" },
        { key: "sex", label: "Sex" },
        { key: "familialdisease", label: "Familial Disease" },
        { key: "environmentalsettings", label: "Environmental Setting" },
        { key: "specificCohort", label: "Cohort" },
      ],
      totalPages: 0,
      totalElements: 0,
      sortBy: "",
      selectedCases: [],
      presentationList: [],
      presentationSlides: [],
      selectedPresentation: null,
      selectedPresentationSlideIds: [],
      presentationsLoading: false,
      presentationSlidesLoading: false,
      getInitialFormState,

      isCheckValidation: false,
      isUploadCaseProcess: false,
      isTumorCaseOrderSaving: false,
      tumorCaseListBeforeDrag: [],
    };
  },
  watch: {
    editId: {
      immediate: true,
      handler(id) {
        if (id && id !== null) {
          this.editing = true;
          this.formLoading = true;
          this.fetchMaterialForEditing(id);
        }
      },
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    isIdReadonly() {
      // Only readonly in edit mode when ID matches the pattern
      if (!this.editId) return false;

      const id = (this.form.id || "").toUpperCase().trim();
      return id.startsWith("TH-COL") || id.startsWith("TH-ASN");
    },
    shouldShowCheckboxes() {
      if (!this.form.slideCollection) {
        return false;
      }

      return true;
    },
    selectedTumorSiteId() {
      const userTumorsiteId = localStorage.getItem("tumorSiteId");
      return this.form.tumorSite ? this.form.tumorSite.id : userTumorsiteId;
    },
    caseNumberPlaceholder() {
      return getTumorSiteCaseNumberPlaceholder(this.selectedTumorSiteId);
    },
  },

  methods: {
    updateTumorCaseFileOrders() {
      this.form.tumorCases.forEach((caseItem, idx) => {
        caseItem.fileOrder = idx + 1;
      });
    },

    handleTumorCaseDragStart() {
      this.tumorCaseListBeforeDrag = JSON.parse(
        JSON.stringify(this.form.tumorCases)
      );
    },

    async handleTumorCaseDragEnd(event) {
      if (
        !event ||
        event.oldIndex === event.newIndex ||
        this.isTumorCaseOrderSaving
      ) {
        return;
      }

      this.updateTumorCaseFileOrders();

      if (!this.editId) {
        return;
      }

      // await this.persistTumorCaseOrder();
    },

    // async persistTumorCaseOrder() {
      // this.isTumorCaseOrderSaving = true;

      // try {
        // const response = await this.$api.updateEducationalMaterial(
        //   this.buildPayload()
        // );

        // if (this.$handleResponse && !this.$handleResponse(response)) {
          // this.form.tumorCases = this.tumorCaseListBeforeDrag;
          // this.updateTumorCaseFileOrders();
          // return;
        // }

        // this.$toastr("success", "Tumor case order updated successfully");
      // } catch (error) {
      //   this.form.tumorCases = this.tumorCaseListBeforeDrag;
      //   this.updateTumorCaseFileOrders();
      //   this.$handleError(error);
      // } finally {
        // this.isTumorCaseOrderSaving = false;
      // }
    // },

    removeCase(index) {
      const removedCase = this.form.tumorCases[index];
      if (this.editing && removedCase.matCaseId) {
        this.removedCases.push(removedCase.matCaseId);
      }

      // Remove from tumorCases
      this.form.tumorCases.splice(index, 1);

      this.updateTumorCaseFileOrders();
    },
    async init() {
      this.isCheckValidation = false;
      await this.getUserProfile(localStorage.getItem("userId"));
    },
    validateAllFileOrders() {
      const selectedValues = this.form.tumorCases.map(
        (caseItem) => caseItem.fileOrder
      );
      const uniqueValues = [...new Set(selectedValues)];
      return selectedValues.length !== uniqueValues.length;
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async validateData() {
      this.isCheckValidation = true;
      await this.sleep(100);
      this.updateTumorCaseFileOrders();

      const hasDuplicateFileOrders = this.validateAllFileOrders();
      const valid = await this.$validator.validate();

      if (!valid || hasDuplicateFileOrders) {
        if (hasDuplicateFileOrders) {
          this.$toastr("error", "Please ensure all file orders are unique.");
        } else {
          this.$toastr("error", this.$t("notes.fillAllValidDetails"));
        }
        return;
      }

      if (!this.form.agreeTerms) {
        this.$toastr("error", "Please agree to the terms.");
        return false;
      }
      this.submitForm();
    },
    getDisplaySlideName(index) {
      return `Slide_${index + 1}.jpg`;
    },
    handleManuallySelectedCases() {
      // Remove duplicates from selected cases
      const uniqueSelectedCases = [...new Set(this.selectedCases)];

      // Get existing case IDs to avoid duplicates
      const existingCaseIds = this.form.tumorCases.map(
        (caseItem) => caseItem.itemType !== "PRESENTATION_SLIDE" ? caseItem.caseId : null
      );

      // Filter out cases that are already added
      const newCases = uniqueSelectedCases.filter(
        (caseId) => !existingCaseIds.includes(caseId)
      );

      if (newCases.length === 0) {
        this.$toastr("info", "All selected cases are already added.");
        this.selectedCases = [];
        this.$bvModal.hide("modal-select-manual");
        return;
      }
      console.log("New cases to add:", newCases);
      this.manuallCaseIds = newCases.join(", ");
      this.selectedCases = [];
      this.$bvModal.hide("modal-select-manual");
      this.$bvModal.hide("modal-add-tumor");
      this.handleAddCasesClick();
    },

    async fetchMaterialForEditing(id) {
      try {
        const response = await this.$api.getEducationalMaterialById(id);
        const eduMaterial = response.data.payload.eduMaterial;
        const caseDetails = response.data.payload.caseDetails;

        let matchedSlideCollection = null;
        if (eduMaterial.slideCollectionType) {
          let slideType = this.type === 'Presentation' ? this.presentationCollections : this.slideCollections;
          matchedSlideCollection = slideType.find(
            (collection) => collection.value === eduMaterial.slideCollectionType
          );
        }

        const matchedTumorSite =
          this.tumorSites.find(
            (site) => site.id === eduMaterial.tumorSite?.id
          ) || null;
        this.form = {
          id: eduMaterial.systemIdNumber || eduMaterial.idNumber || "",
          name: eduMaterial.title || "",
          description: eduMaterial.description || "",
          tumorSite: matchedTumorSite || null,
          difficultyLevel:
            this.difficultyLevels.find(
              (level) => level.value === eduMaterial.difficultyLevel
            ) || "",
          slideCollection: matchedSlideCollection,
          slideCollectionType: eduMaterial.slideCollectionType || null,
          hideCaseNotes:
            eduMaterial.isHideCaseNotes === true ||
            eduMaterial.isHideCaseNotes === 1 ||
            eduMaterial.isHideCaseNotes === "1",
          hideDemographics:
            eduMaterial.isHidePatientInfo === true ||
            eduMaterial.isHidePatientInfo === 1 ||
            eduMaterial.isHidePatientInfo === "1",
          enableUnhide:
            eduMaterial.isDiagnosisUnhide === true ||
            eduMaterial.isDiagnosisUnhide === 1 ||
            eduMaterial.isDiagnosisUnhide === "1",
          isRecommendedWtr: !!eduMaterial.isRecommendedWtr,
          isShowPublicSite: !!eduMaterial.isShowPublicSite,
          tumorCases: (caseDetails || [])
            .slice()
            .sort(
              (a, b) => (a.eduCases.orderNo || 0) - (b.eduCases.orderNo || 0)
            )
            .map((c) => {
              const itemType = c.eduCases.itemType || c.itemType || "CASE";
              if (itemType === "PRESENTATION_SLIDE") {
                const slide = c.presentationSlide || {};
                return {
                  itemType,
                  presentationSlideId: c.eduCases.presentationSlideId || slide.id,
                  fileOrder: c.eduCases.orderNo || 1,
                  comment: c.eduCases.comment || "",
                  answerComments: c.eduCases.answerComments || "",
                  resourceId: slide.resourceId,
                  containerName: slide.containerName,
                  src: slide.thumbnailPath || slide.path,
                  name: slide.name,
                  matCaseId: c.eduCases.matCaseId,
                };
              }
              return {
                itemType: "CASE",
                caseId: c.caseInfo.caseId,
                ...(this.type === "Assignment" ? {
                  caseSlideIds: c.caseInfo.caseSlideIds,
                  caseNumber: c.caseInfo.caseNumber || null,
                } : {}),
                fileOrder: c.eduCases.orderNo || 1,
                comment: c.eduCases.comment || "",
                answerComments: c.eduCases.answerComments || "",
                resourceId: c.caseInfo.resourceId,
                containerName: c.caseInfo.containerName,
                src: c.caseInfo.thumbnailPath,
                matCaseId: c.eduCases.matCaseId,
              };
            }),
          agreeTerms: false,
          createdBy: this.editing
            ? this.selectedUserId.split("-")[0].trim()
            : this.form.createdBy,
          isShowPublicSiteEditor: eduMaterial.isShowPublicSiteEditor,
          systemIdNumber: eduMaterial.systemIdNumber,
          idNumber: eduMaterial.idNumber,
        };
        this.updateTumorCaseFileOrders();
        this.formLoading = false;
      } catch (error) {
        this.$handleError(error);
        this.formLoading = false;
      }
    },

    async handleAddCasesClick() {
      this.tumorCasesLoading = true;
      const inputString = this.manuallCaseIds || this.caseIds;
      const idsArray = inputString
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "");

      if (!idsArray.length) {
        this.tumorCasesLoading = false;
        return;
      }

      try {
        // Remove duplicates from input
        const uniqueIdsArray = [...new Set(idsArray)];

        // Get existing case IDs to avoid duplicates
        const existingCaseIds = this.form.tumorCases.map(
          (caseItem) => caseItem.itemType !== "PRESENTATION_SLIDE" ? caseItem.caseId : null
        );

        // Filter out IDs that already exist
        const newIdsArray = uniqueIdsArray.filter(
          (id) => !existingCaseIds.includes(id)
        );

        if (newIdsArray.length === 0) {
          this.$toastr("info", "All provided case IDs are already added.");
          this.$bvModal.hide("modal-add-tumor");
          this.tumorCasesLoading = false;
          return;
        }

        const tumorSiteId =
          this.form.tumorSite?.id ||
          (this.tumorSites[0] && this.tumorSites[0].id) ||
          null;

        await this.sleep(100);
        const caseDetailsResp = await this.$api.getCaseDetailsByNumber(
          tumorSiteId,
          newIdsArray
        );

        if (this.$handleResponse && !this.$handleResponse(caseDetailsResp)) {
          this.tumorCasesLoading = false;
          return;
        }

        const casesPayload = caseDetailsResp.data.payload || [];

        // Additional check to ensure no duplicates in API response
        const uniqueCasesPayload = casesPayload.filter(
          (caseData, index, self) =>
            index === self.findIndex((c) => c.caseId === caseData.caseId)
        );

        // Filter out cases that might still be duplicates (in case API returns duplicates)
        const finalCasesToAdd = uniqueCasesPayload.filter(
          (caseData) => !existingCaseIds.includes(caseData.caseId)
        );

        // Add unique cases
        for (const caseData of finalCasesToAdd) {
          this.form.tumorCases.push({
            itemType: "CASE",
            caseId: caseData.caseId,
            ...(this.type === "Assignment" ? {
              caseNumber: caseData.caseNumber || null,
              caseSlideIds: caseData.caseSlideIds,
            } : {}),
            fileOrder: this.form.tumorCases.length + 1,
            comment: "",
            answerComments: "",
            resourceId: caseData.resourceId,
            containerName: caseData.containerName,
            src: caseData.thumbnailPath,
          });
        }
        this.updateTumorCaseFileOrders();
      } catch (err) {
        if (this.$handleError) this.$handleError(err);
        else console.error("Error while adding cases", err);
      } finally {
        this.caseIds = "";
        this.manuallCaseIds = "";
        this.$bvModal.hide("modal-add-tumor");
        this.tumorCasesLoading = false;
      }
    },
    getUserProfile(userId) {
      this.$api.getUserFact(userId).then(
        (response) => {
          const userProfile = response.data;
          this.form.createdBy = userProfile.firstName.concat(
            userProfile.middleName ? " " + userProfile.middleName : "",
            userProfile.lastName ? " " + userProfile.lastName : ""
          );
        },
        (error) => {
          this.$handleError(error);
        }
      );
    },
    buildPayload() {
      this.updateTumorCaseFileOrders();

      // Filter out cases that were removed
      const activeCases = this.form.tumorCases.filter(
        (caseItem) => !this.removedCases.includes(caseItem.matCaseId)
      );

      const eduCases = activeCases.map((row, idx) => {
        const itemType = row.itemType || "CASE";
        const caseObj = {
          itemType,
          orderNo: Number(row.fileOrder) || idx + 1,
          comment: row.comment || "",
        };
        if (this.type === "Assignment") {
          caseObj.answerComments = row.answerComments || "";
        }
        if (itemType === "PRESENTATION_SLIDE") {
          caseObj.presentationSlideId = Number(row.presentationSlideId);
        } else {
          caseObj.caseId = Number(row.caseId);
        }

        // Add matCaseId only if editing
        if (this.editId && row.matCaseId) {
          caseObj.matCaseId = row.matCaseId;
        }

        return caseObj;
      });
      const eduMaterial = {
        type: this.type || "Collection",
        idNumber: this.form.systemIdNumber ? this.form.idNumber : this.form.id,
        title: this.form.name,
        description: this.form.description || "",
        difficultyLevel: this.form.difficultyLevel.value || null,
        slideCollectionType: (this.type === 'Assignment') ? 'UNKNOWN_SLIDES_ASSIGNMENT' : (this.form.slideCollection) ? this.form.slideCollection.value : null,
        isHideCaseNotes: this.form.hideCaseNotes ? 1 : 0,
        isHidePatientInfo: this.form.hideDemographics ? 1 : 0,
        isDiagnosisUnhide: this.form.enableUnhide ? 1 : 0,
        isRecommendedWtr: this.form.isRecommendedWtr || 0,
        isShowPublicSiteEditor: this.form.isShowPublicSiteEditor ? 1 : 0,
        isShowPublicSite: this.editing
          ? this.form.isShowPublicSite
            ? 1
            : 0
          : 0,
        createdBy: this.currentFolder
          ? this.currentFolder.id
          : this.form.createdBy,
        tumorSite: this.form.tumorSite,
      };
      if (this.editId) {
        eduMaterial.id = this.editId;
      }

      return { eduMaterial, eduCases };
    },

    // Creates a new educational material
    async createMaterial() {
      try {
        const payload = this.buildPayload();

        const resp = await this.$api.addEducationalMaterial(payload);

        if (this.$handleResponse && !this.$handleResponse(resp)) {
          return false;
        }
        this.$toastr("success", "Educational Material created successfully");
        this.$emit("saved");
        return true;
      } catch (err) {
        this.handleApiError(err, "create");
        this.isUploadCaseProcess = false;
        return false;
      }
    },

    // Updates an existing educational material
    async updateMaterial() {
      try {
        if (this.removedCases.length > 0) {
          await this.deleteRemovedCases();
        }
        const payload = this.buildPayload();
        const resp = await this.$api.updateEducationalMaterial(payload);

        if (this.$handleResponse && !this.$handleResponse(resp)) {
          return false;
        }

        this.$toastr("success", "Educational Material updated successfully");
        this.$emit("saved");
        return true;
      } catch (err) {
        this.isUploadCaseProcess = false;
        this.handleApiError(err, "update");
        return false;
      }
    },
    async deleteRemovedCases() {
      try {
        // Create array of delete promises
        const deletePromises = this.removedCases.map((id) =>
          this.$api.deleteEduMaterialTumorCase(id)
        );

        // Execute all deletes
        await Promise.all(deletePromises);

        // Clear removed cases after successful deletion
        console.log("Deleted cases:", this.removedCases);
        this.removedCases = [];
        console.log("Removed cases cleared");
      } catch (error) {
        console.error("Failed to delete cases:", error);
        throw error; // Propagate error to updateMaterial
      }
    },
    // Unified error handler
    handleApiError(err, operation) {
      const operationName = operation === "create" ? "creation" : "update";
      const errorMessage = err.response?.data?.message || err.message;

      if (this.$handleError) {
        this.$handleError(err);
      } else {
        console.error(`${operationName} error`, err);
        alert(`Error during ${operationName}: ${errorMessage}`);
      }
    },

    // Main submission handler
    async submitForm() {
      let success = false;
      this.isUploadCaseProcess = true;
      if (this.editing) {
        success = await this.updateMaterial();
      } else {
        success = await this.createMaterial();
      }

      // Clear the submission state on success.
      if (success) {
        this.isUploadCaseProcess = false;
      }
    },
    async getAllMetaData(hasFilters = true, value, sortType, searchObj = {}) {
      try {
        this.listLoading = true;
        const updatedParams = value || this.paramsUtil;
        this.paramsUtil = updatedParams;

        // Use filters from manual-case-filter if available
        const filters = hasFilters ? { ...this.filterList, ...searchObj } : {};
        const searchObject = {
          age: filters.age || [0, 0],
          country: filters.country || null,
          environmentalSettings: filters.environmentalSettings || null,
          familialDisease: filters.familialDisease || null,
          riskFactor: filters.riskFactor || null,
          biomarkerProfile: filters.biomarkerProfile || null,
          neoadjuvantTreatment: filters.neoadjuvantTreatment || null,
          genetic: null,
          sex: filters.gender || null,
          specificCohortId: filters.specificCohortId || null,
          tumorSiteId: this.form.tumorSite?.id ? String(this.form.tumorSite?.id) : localStorage.getItem("tumorSiteId"),
          tumorTypeId: filters.tumorType || null,
          tumorSubTypeId: filters.tumorSubType || null,
          geographicRegionId: filters.region || 0,
          casenotes: filters.casenotes || null,
          sortType: updatedParams.isSorted ? updatedParams.sortType : sortType,
        };

        const resp = await this.$api.getMetaDataListFact(
          updatedParams,
          searchObject
        );

        const { content, totalPages, totalElements } = resp.data.payload;
        this.searchResult = content;
        this.totalPages = totalPages;
        this.totalElements = totalElements;
      } catch (err) {
        this.$handleError(err);
      } finally {
        this.listLoading = false;
      }
    },
    onSearchTopFilter(searchObj) {
      this.gridType = searchObj.gridType ?? false;
      this.filterList = { ...searchObj };
      delete this.filterList.gridType; // Remove gridType as it's not a filter for API

      // Reset to first page when filters change
      this.paramsUtil = {
        page: 0,
        size: this.paramsUtil.size,
        sort: this.paramsUtil.sort,
        isSorted: this.paramsUtil.isSorted,
      };

      this.getAllMetaData(true, this.paramsUtil, undefined, this.filterList);
    },
    onGridMode(type) {
      this.gridType = type;
    },
    onFilterChange(newFilters) {
      this.filterList = newFilters;
    },
    onClearList() {
      this.filterList = {};
      this.paramsUtil = {
        page: 0,
        size: 10,
        sort: "cd.system_case_number,desc",
        isSorted: false,
      };
      this.getAllMetaData(false, this.paramsUtil, undefined);
    },
    handleSizeChange(size) {
      this.paramsUtil.size = size;
      this.paramsUtil.page = 0;
      this.getAllMetaData(false, this.paramsUtil, undefined);
    },
    handlePageChange(page) {
      this.paramsUtil.page = page - 1;
      this.getAllMetaData(false, this.paramsUtil, undefined);
    },
    sortMetadata(type, sortType) {
      this.sortBy = this.sortList(type, this.sortBy);
      this.paramsUtil = {
        ...this.paramsUtil,
        sort: this.sortBy,
        isSorted: true,
        sortType,
      };
      this.getAllMetaData(true, this.paramsUtil, sortType);
    },
    sortList(type, currentSortBy) {
      if (currentSortBy.includes(type)) {
        return currentSortBy.includes("asc") ? `${type},desc` : `${type},asc`;
      }
      return `${type},asc`;
    },
    viewCaseInfo(caseItem, event) {
      if (this.type !== "Assignment" || caseItem.itemType === "PRESENTATION_SLIDE") return;
      if (event) event.preventDefault();

      const caseSlideIds = String(caseItem.caseSlideIds || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean)
        .join(",");
      if (!caseItem.caseId || !caseSlideIds) {
        this.$toastr("error", "No slides are available to view for this case.");
        return;
      }

      this.$changeRouteToTab({
        name: "display-viewer",
        params: {
          id: caseSlideIds.split(",")[0],
          caseDetailId: caseItem.caseId,
          movedToEditorialBox: false,
          movedToSlideLibrary: true,
          sharedToEditor: false,
          isPublicSite: false,
          caseSlideIds,
          selectedFolderView: "",
          selectedFolderUserRole: "",
          selectedFolderUserRegion: "",
          selectedCaseRegion: "",
        },
        query: null,
      });
    },
    viewSlide(item) {
      let id = 0;
      if (item.caseSlideIds.includes(",")) {
        const splitIds = item.caseSlideIds.split(",");
        id = splitIds[0];
      } else {
        id = item.caseSlideIds;
      }

      const route = "display-viewer";
      const params = {
        id: id,
        caseDetailId: item.caseDetailId,
        movedToEditorialBox: false,
        movedToSlideLibrary: true,
        sharedToEditor: false,
        isPublicSite: true,
        caseSlideIds: item.caseSlideIds,
        selectedFolderView: "",
        selectedFolderUserRole: "",
        selectedFolderUserRegion: "",
        selectedCaseRegion: "",
      };
      this.$changeRouteToTab({
        name: route,
        params,
        query: null,
      });
    },
    openPresentationSlideSelector() {
      this.$bvModal.show("modal-select-presentation-slides");
    },
    async loadPresentationList() {
      this.presentationsLoading = true;
      this.presentationSlides = [];
      this.selectedPresentation = null;
      this.selectedPresentationSlideIds = [];
      try {
        const response = await this.$api.getPresentationByFolder(
          {
            // folderId: 9,
            userId: localStorage.getItem("userId"),
            size: 200,
            sort: "createdDate,desc",
          },
          {}
        );
        const payload = response && response.data && response.data.payload;
        this.presentationList = payload && payload.content ? payload.content : payload || [];
        if (this.presentationList.length) {
          await this.selectPresentation(this.presentationList[0]);
        }
      } catch (error) {
        this.$handleError(error);
        this.presentationList = [];
      } finally {
        this.presentationsLoading = false;
      }
    },
    async selectPresentation(presentation) {
      this.selectedPresentation = presentation;
      this.selectedPresentationSlideIds = [];
      this.presentationSlidesLoading = true;
      try {
        const response = await this.$api.getPresentationSlides(presentation.id, {
          size: 200,
          sort: "order,asc",
        });
        const payload = response && response.data && response.data.payload;
        this.presentationSlides = payload && payload.content ? payload.content : payload || [];
      } catch (error) {
        this.$handleError(error);
        this.presentationSlides = [];
      } finally {
        this.presentationSlidesLoading = false;
      }
    },
    handlePresentationSlidesSelected() {
      const existingSlideIds = this.form.tumorCases
        .filter((item) => item.itemType === "PRESENTATION_SLIDE")
        .map((item) => Number(item.presentationSlideId));
      const slidesToAdd = this.presentationSlides.filter(
        (slide) =>
          this.selectedPresentationSlideIds.includes(slide.id) &&
          !existingSlideIds.includes(Number(slide.id))
      );

      if (!slidesToAdd.length) {
        this.$toastr("info", "All selected slides are already added.");
        this.selectedPresentationSlideIds = [];
        return;
      }

      slidesToAdd.forEach((slide) => {
        this.form.tumorCases.push({
          itemType: "PRESENTATION_SLIDE",
          presentationSlideId: slide.id,
          fileOrder: this.form.tumorCases.length + 1,
          comment: "",
          answerComments: "",
          resourceId: slide.resourceId,
          containerName: slide.containerName,
          src: slide.thumbnailPath || slide.path,
          name: slide.name,
        });
      });
      this.selectedPresentationSlideIds = [];
      this.$bvModal.hide("modal-select-presentation-slides");
    },
    resetForm() {
      this.form = this.getInitialFormState();
      this.removedCases = [];
      this.caseIds = "";
      this.selectedCases = [];
      this.presentationList = [];
      this.presentationSlides = [];
      this.selectedPresentation = null;
      this.selectedPresentationSlideIds = [];
      this.editing = false;

      // Reset validation errors
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    async showForm() {
      // For new materials, ensure we have user profile data
      if (!this.userCreatedBy) {
        await this.getUserProfile(localStorage.getItem("userId"));
      }

      this.resetForm();

      // If editing, fetch the latest data
      if (this.editId) {
        this.editing = true;
        this.formLoading = true;
        await this.fetchMaterialForEditing(this.editId);
      }
    },

    // Your existing methods remain the same, but update cancel method:
    cancel() {
      this.$bvModal.hide("create-material-modal");
      this.resetForm();
    },
    manageSelectionofTumorSite() {
      if (this.form.tumorSite == null && this.userRole === this.ROLE_TENANT_ADMIN) {
        this.$toastr("info", "Please Select Tumor Site First");
        return false
      }
      this.$bvModal.show('modal-add-tumor')
    }
  },
};
</script>

<style scoped>
.case-collection {
  background-color: #fff;
}

.bg-primary {
  background-color: #2b5797 !important;
}

.table th,
.table td {
  vertical-align: middle;
}

.preview-img {
  height: 60px;
}

.preview-img img {
  height: 100%;
}
.tumor-case-drag-column {
  width: 42px;
}
.tumor-case-drag-handle {
  cursor: grab;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}
.tumor-case-drag-handle.drag-disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.sortable-ghost {
  opacity: 0.6;
}
.diagnosis-box-case-info {
  font-size: 14px;
}
.diagnosis-box-case-number {
  color: #000;
}

.diagnosis-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}

.diagnosis-grid > .diagnosis-grid-item {
  flex: none;
  max-width: none;
  min-width: 0;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
}

.diagnosis-box {
  height: 205px;
  width: 100%;
  border: 1px solid #707070;
  border-radius: 0px;
  box-shadow: none;
  padding: 10px 10px 0 10px;
  background-color: #fff;
  color: #000000;
  margin-bottom: 12px;
  overflow: hidden;
}
.header-label {
  font-size: 45px;
  font-weight: 700;
  text-shadow: 0px 0px 6px #fff, 0px 0px 4px #fff, 0px 0px 0px #fff,
    0px 0px 0px #fff;
}
.diagnosis-box .diagnosis-img-box {
  height: 195px;
  min-width: 0;
}

.diagnosis-box .diagnosis-img-box .diagnosis-img-blur {
  object-fit: cover;
  filter: grayscale(50%) blur(2px) opacity(0.2);
}

.diagnosis-box .diagnosis-img-box .diagnosis-img {
  object-fit: contain;
  position: absolute;
  top: 50px;
  left: 0;
}

.diagnosis-box .diagnosis-img-box .thum-img {
  max-height: 150px;
  margin-bottom: 5px;
  min-height: 150px;
  object-fit: contain;
}

.diagnosis-box .diagnosis-title {
  font-size: 1rem;
  line-height: 1.4;
  padding-top: 4px;
  padding-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; /* replacement for .single-line-text */
}

.diagnosis-box .diagnosis-footer {
  font-size: 14px;
  padding-top: 2px;
  border-top: 1px solid #d2d6de;
}

.diagnosis-box .diagnosis-text {
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  height: auto;
  margin: 0;
  line-height: normal;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}

.diagnosis-box .diagnosis-note {
  padding-top: 4px;
  font-size: 13px;
  margin: 0;
  line-height: normal;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 991.98px) {
  .diagnosis-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 767.98px) {
  .diagnosis-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575.98px) {
  .diagnosis-grid {
    grid-template-columns: 1fr;
  }
}
</style>
